/* eslint-disable react/prop-types */
import React, { Component } from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { Redirect, Link } from "react-router-dom";
import Button from "components/CustomButtons/Button.js";
import EditIcon from "@material-ui/icons/Edit";
import axios from "axios";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Loader from "components/Loader";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
// import editorConfiguration from "../variables/EditorConfiguration";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import styles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import SnackbarContent from "components/Snackbar/SnackbarContent.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Constants from "variables/AppConstants";
const classes = makeStyles(styles);
class UpdateQuery extends Component {
  state = {
    userQuestion: "",
    subject: "",
    chapter: "",
    answer: "",
    queryFile: "",
    files: [],
    fileExtension: "",
    subjects: [],
    filteredChapters: [],
    subjectId: "",
    levelId: "",
    chapterId: "",
    queryId: "",
    question: "",
    description: "",
    levels: [],
    filteredSubjects: [],
    redirect: false,
    show: false,
    loading: false,
    questionId: "",
    status: "",
  };

  componentDidMount() {
    axios.get(Constants.getUrls.levels).then((resp) => {
      this.setState(
        {
          levels: resp.data.levels,
        },
        () => {
          this.setState(
            {
              filteredSubjects: this.state.levels.find(
                (level) => level.id === this.state.levelId
              ).subjects,
            },
            () => {
              this.setState({
                filteredChapters: this.state.filteredSubjects.find(
                  (subject) => subject.id === this.state.subjectId
                ).chapters,
              });
            }
          );
        }
      );
      // console.log(this.state.levels);
    });
    const queryData = this.props.location.state.questionData;
    // console.log(queryData);
    this.setState(
      {
        questionId: queryData.id,
        userQuestion: queryData.question,
        subject: queryData.subject.name,
        chapter: queryData.chapter.name,
        queryFile: queryData.img_url,
        queryId: queryData.id,
        levelId: parseInt(queryData.level_id),
        subjectId: parseInt(queryData.subject_id),
        chapterId: parseInt(queryData.chapter_id),
        status: queryData.status,
        answer: queryData.answer,
      },
      () => {
        // console.log(this.state.userQuestion);
      }
    );

    // console.log(this.state.subjectId);
    // console.log(this.state.chapterId);
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({
      loading: true,
    });
    const payLoad = {
      levelId: parseInt(this.state.levelId),
      subjectId: parseInt(this.state.subjectId),
      chapterId: parseInt(this.state.chapterId),
      queryId: parseInt(this.state.queryId),
      question: this.state.userQuestion,
      description: this.state.description,
      _method: "put",
      status: this.state.status,
      answer: this.state.answer,
    };
    // console.log(payLoad);
    axios
      .post(Constants.updateUrls.updateQueries + this.state.questionId, payLoad)
      .then(() => {
        // console.log(resp);
        this.setState({ loading: false, show: true });
        setTimeout(() => {
          this.setState({
            redirect: true,
          });
        }, 1000);
      });
  };
  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handleLevel = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        const singleLevel = this.state.levels.find(
          (level) => level.id === this.state.levelId
        );
        // console.log(singleLevel);
        this.setState({
          filteredSubjects: singleLevel.subjects,
        });
      }
    );
  };
  handleSubject = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        const singleSubject = this.state.filteredSubjects.find(
          (subject) => subject.id === this.state.subjectId
        );
        // console.log(singleSubject);

        this.setState({
          filteredChapters: singleSubject.chapters,
        });
      }
    );
  };
  render() {
    if (this.state.redirect) {
      return <Redirect to={"/admin/appquestions"} />;
    } else {
      return (
        <div>
          <GridContainer>
            {this.state.show ? (
              <div style={{ position: "relative", left: "600px" }}>
                <SnackbarContent
                  message={"Question Updated!"}
                  icon={AddAlert}
                  color="success"
                />
              </div>
            ) : null}
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="rose" icon>
                  <CardIcon color="danger">
                    <EditIcon />
                  </CardIcon>
                  <h4 style={{ color: "black" }}>Edit A Question</h4>
                </CardHeader>
                <CardBody>
                  <form onSubmit={this.handleSubmit}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <FormControl
                          style={{ marginTop: "12px" }}
                          fullWidth
                          className={classes.selectFormControl}
                        >
                          <InputLabel
                            htmlFor="simple-select"
                            className={classes.selectLabel}
                          >
                            Level
                          </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu,
                            }}
                            classes={{
                              select: classes.select,
                            }}
                            value={this.state.levelId}
                            inputProps={{
                              required: true,
                              name: "levelId",
                              id: "simple-select",
                              onChange: this.handleLevel,
                            }}
                          >
                            {this.state.levels.map((v, i) => (
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                                key={i}
                                value={v.id}
                              >
                                {v.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {/* {this.state.cAlert ? (
                          <div>
                            <span style={{ color: "red" }}>*required</span>
                          </div>
                        ) : null} */}
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <FormControl
                          style={{ marginTop: "12px" }}
                          fullWidth
                          className={classes.selectFormControl}
                        >
                          <InputLabel
                            htmlFor="simple-select"
                            className={classes.selectLabel}
                          >
                            Subject
                          </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu,
                            }}
                            classes={{
                              select: classes.select,
                            }}
                            value={this.state.subjectId}
                            inputProps={{
                              name: "subjectId",
                              id: "simple-select",
                              onChange: this.handleSubject,
                            }}
                          >
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected,
                              }}
                            >
                              Select Level First
                            </MenuItem>
                            {this.state.filteredSubjects.map((v, i) => (
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                                key={i}
                                value={v.id}
                              >
                                {v.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {/* {this.state.bAlert ? (
                          <div>
                            <span style={{ color: "red" }}>*required</span>
                          </div>
                        ) : null} */}
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <FormControl
                          style={{ marginTop: "12px" }}
                          fullWidth
                          className={classes.selectFormControl}
                        >
                          <InputLabel
                            htmlFor="simple-select"
                            className={classes.selectLabel}
                          >
                            Chapters
                          </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu,
                            }}
                            classes={{
                              select: classes.select,
                            }}
                            value={this.state.chapterId}
                            inputProps={{
                              required: true,
                              name: "chapterId",
                              id: "simple-select",
                              onChange: (e) => {
                                this.setState({ chapterId: e.target.value });
                              },
                            }}
                          >
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected,
                              }}
                              value=""
                            >
                              Select Subject First
                            </MenuItem>
                            {this.state.filteredChapters.map((v, i) => (
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                                key={i}
                                value={v.id}
                              >
                                {v.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {/* {this.state.dAlert ? (
                          <div>
                            <span style={{ color: "red" }}>*required</span>
                          </div>
                        ) : null} */}
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <br />
                        <label>Question</label>
                        <br />
                        <CKEditor
                          required={true}
                          editor={ClassicEditor}
                          data={this.props.location.state.questionData.question}
                          // config={editorConfiguration}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            //console.log({ data });
                            this.setState({
                              question: data,
                              aAlert: false,
                            });
                          }}
                        />
                        {this.state.aAlert ? (
                          <div>
                            <span style={{ color: "red" }}>*required</span>
                          </div>
                        ) : null}
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <Button className="" color="warning" type="submit">
                          {this.state.loading ? <Loader /> : "Update Question"}
                        </Button>
                        <Link
                          to={{
                            pathname: "/admin/appquestions",
                          }}
                        >
                          <Button className="btn-round" color="danger">
                            Cancel
                          </Button>
                        </Link>
                      </GridItem>
                    </GridContainer>
                  </form>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      );
    }
  }
}

export default UpdateQuery;
